import { Link } from 'gatsby';
import React, { useContext } from 'react';
import styled, { css } from 'styled-components';

import { Logo, HeartioLogo } from '../../icons';
import { QuizContext } from '../../store/quiz';
import { media } from '../../utils/styles';

export const Header = ({ heartio }) => {
  const {
    store: { currentScreenIndex, lastScreenIndex },
  } = useContext(QuizContext);

  const showProgress = currentScreenIndex > 0;

  return (
    <Wrap $absolute={currentScreenIndex === 0}>
      {showProgress && <Progress $current={currentScreenIndex} $total={lastScreenIndex} />}
      <Link to="/">{!heartio ? <Logo /> : <HeartioLogo />}</Link>
      {showProgress && (
        <Steps>
          {currentScreenIndex > lastScreenIndex ? lastScreenIndex : currentScreenIndex} of{' '}
          {lastScreenIndex}
        </Steps>
      )}
    </Wrap>
  );
};

const Progress = styled.div`
  position: absolute;
  top: 0;
  left: 20px;
  width: calc(100% - 40px);
  height: 6px;
  background: ${({ theme }) => theme.secondary};
  &::before {
    position: absolute;
    z-index: 2;
    left: 0;
    top: 0;
    content: '';
    width: ${p => (p.$current / p.$total) * 100}%;
    max-width: 100%;
    height: 100%;
    transition: 0.3s ease-out width;
    background: ${({ theme }) => theme.primary};
  }
  ${media.phone} {
    top: auto;
    bottom: 0;
    left: 0;
    width: 100%;
  }
`;

const Steps = styled.div`
  font-size: 16px;
  line-height: 28px;
  color: #000000;
  ${media.phone} {
    position: absolute;
    right: 24px;
    top: calc(100% + 18px);
  }
`;

const Wrap = styled.header`
  position: relative;
  ${p =>
    p.$absolute &&
    css`
      position: absolute;
    `}
  height: 104px;
  width: 1048px;
  padding: 0 20px;
  max-width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 auto;
  > svg {
    width: 132px;
  }
  ${media.phone} {
    height: 88px;
    justify-content: center;
  }
`;
